<template>
  <DeckControlsContainer class="absolute left-4 transform -translate-y-1/2 top-1/2" padding-size="sm">
    <DeckControlButton class="h-12" data-testid="sidebar-toggle" @click="$emit('click')">
      <ChevronLeftIcon v-if="isSidebarOpen" class="w-6 h-6" />
      <ChevronRightIcon v-else class="w-6 h-6" />
    </DeckControlButton>
  </DeckControlsContainer>
</template>

<script lang="ts" setup>
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'

defineProps({
  isSidebarOpen: {
    type: Boolean,
    required: true,
  },
})

defineEmits(['click'])
</script>
